import { useMutation } from '@apollo/client';
import { RequestQuoteOutlined, TextSnippetOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { ExtendedList } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { INTAKE_REQUEST_DESCRIPTION } from '../IntakeRequestDescriptionStep/IntakeRequestDescriptionStep.query.gql';
import { SvbrgChatSessionVariant } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { GuidedDialogAction } from '~/components/GuidedDialog/components/GuidedDialogAction/GuidedDialogAction';
import { useChatSession } from '~/modules';

import { INTAKE_SELECT_INTENT_STEP_MUTATION } from './IntakeSelectIntentStepMutation.gql';

export const IntakeIntentSelectionStep = ({ isCompleted, createdBy, role }: ChatMessageProps) => {
  const { t: tGlobal } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeIntentSelectionStep' });
  const { user } = useAuth();
  const session = useChatSession();
  const [selectIntent] = useMutation(INTAKE_SELECT_INTENT_STEP_MUTATION, {
    refetchQueries: [{ query: INTAKE_REQUEST_DESCRIPTION, variables: session }],
  });
  return (
    <ChatStep
      title={tGlobal('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message', {
        firstName: user?.profile.given_name,
        lastName: user?.profile.family_name,
      })}
    >
      <Box
        sx={{
          paddingY: 2,
        }}
      >
        <ExtendedList sx={{ flexDirection: 'row', display: 'flex', gap: 4 }}>
          <GuidedDialogAction
            title={t('options.request.title')}
            description={t('options.request.description')}
            disabled={isCompleted}
            onClick={() => {
              selectIntent({
                variables: {
                  data: {
                    id: session.id,
                    intent: SvbrgChatSessionVariant.REQUEST_FORM,
                  },
                },
              });
            }}
            startIcon={<TextSnippetOutlined />}
          />
          <GuidedDialogAction
            title={t('options.quote.title')}
            description={t('options.quote.description')}
            disabled={isCompleted}
            onClick={() => {
              selectIntent({
                variables: {
                  data: {
                    id: session.id,
                    intent: SvbrgChatSessionVariant.REQUEST_QUOTE,
                  },
                },
              });
            }}
            startIcon={<RequestQuoteOutlined />}
          />
        </ExtendedList>
      </Box>
    </ChatStep>
  );
};
